import React from 'react';
import PropTypes from 'prop-types';

const Layers03 = ({color = 'currentColor', ...props}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.5 7.68525L17 9.47927L9 13.5799L1 9.47927L4.56397 7.65246M13.5 11.6054L17 13.3994L9 17.5L1 13.3994L4.56397 11.5726M9 1.5L17 5.60062L9 9.70124L1 5.60062L9 1.5Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Layers03.propTypes = {
  color: PropTypes.string,
};

export default Layers03;
